class RamblerLazyImage extends HTMLElement {
  connectedCallback() {
    if (!this.querySelector('template')) return;
    const slide = this.closest('.lifestyle-carousel__slide') || this;
    if (!('IntersectionObserver' in window)) {
      this.load();
      return;
    }
    this.observer = new IntersectionObserver((entries) => {
      if (entries.some((entry) => entry.isIntersecting)) this.load();
    }, { rootMargin: '200px 0px' });
    this.observer.observe(slide);
  }

  load() {
    const template = this.querySelector('template');
    if (!template) return;
    this.observer?.disconnect();
    template.replaceWith(template.content);
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }
}

if (!customElements.get('rr-lazy-image')) {
  customElements.define('rr-lazy-image', RamblerLazyImage);
}

class RamblerLifestyleGallery extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    const options = { signal: this.controller.signal };
    this.current = 0;
    this.addEventListener('click', (event) => {
      const control = event.target.closest('[data-step], [data-index]');
      if (!control) return;
      this.goTo(control.hasAttribute('data-step')
        ? this.current + Number(control.dataset.step)
        : Number(control.dataset.index));
    }, options);
    this.addEventListener('touchstart', (event) => {
      this.touchX = event.changedTouches[0].screenX;
    }, { ...options, passive: true });
    this.addEventListener('touchend', (event) => {
      const delta = this.touchX - event.changedTouches[0].screenX;
      if (Math.abs(delta) >= 50) this.goTo(this.current + (delta > 0 ? 1 : -1));
    }, { ...options, passive: true });
    window.addEventListener('resize', () => this.goTo(this.current), options);
    if ('IntersectionObserver' in window) {
      this.videoObserver = new IntersectionObserver((entries) => {
        entries.forEach(({ target, isIntersecting }) => {
          if (isIntersecting) target.play().catch(() => {});
          else target.pause();
        });
      }, { threshold: 0.5 });
      this.querySelectorAll('video').forEach((video) => this.videoObserver.observe(video));
    }
  }

  goTo(index) {
    const track = this.querySelector('.lifestyle-carousel__track');
    const dots = [...this.querySelectorAll('.lifestyle-dot')];
    if (!track || !dots.length) return;
    const desktop = window.matchMedia('(min-width: 768px)').matches;
    this.current = desktop
      ? Math.min(Math.max(index, 0), Math.max(dots.length - 3, 0))
      : (index + dots.length) % dots.length;
    track.style.transform = `translateX(-${this.current * (desktop ? 100 / 3 : 100)}%)`;
    dots.forEach((dot, i) => { dot.setAttribute('aria-current', String(i === this.current)); });
  }

  disconnectedCallback() {
    this.controller?.abort();
    this.videoObserver?.disconnect();
  }
}

if (!customElements.get('rr-lifestyle-gallery')) {
  customElements.define('rr-lifestyle-gallery', RamblerLifestyleGallery);
}

